import React from 'react'
import classNames from 'classnames'
import { Grid, GridItem } from '@deal/components'
import { useNavigationContext } from '#src/components/Header/StandardHeader/NavigationContext'
import { DepartmentNavigationLinkFragment } from '#src/components/Header/NavHierarchyFragments.generated'
import ArrowRight from '#src/components/Header/StandardHeader/icons/arrow-right.svg'
import MenuHeader from '../MenuHeader'
import styles from './styles.css'

interface ActiveSubSectionsMenuProps {
  onNavItemSelected: (link: DepartmentNavigationLinkFragment) => void
}

const ActiveSubSectionsMenu: React.FC<ActiveSubSectionsMenuProps> = ({ onNavItemSelected }) => {
  const navContext = useNavigationContext()
  const subSections = navContext?.activeSubSections.filter(subSection => subSection.showIfSmallSize)

  const menuHeader = navContext?.categorySlugConstraint || navContext?.activeCategory?.label

  return (
    <div
      className={classNames(styles.menu, {
        [styles.visible]: !!navContext?.activeCategory
      })}
    >
      <Grid>
        <GridItem col={2}>
          <MenuHeader
            onBack={() => {
              navContext?.onSetActiveCategory(null)
            }}
            header={menuHeader}
          />

          <ul className={styles.list}>
            {subSections &&
              subSections.map(subSection => {
                const triggersChildList =
                  subSection.__typename === 'DepartmentNavigationListSubSection' &&
                  subSection.items.length > 0

                return (
                  <li
                    key={`mobile${subSection.id}`}
                    className={styles.listItem}
                    onClick={() => {
                      if (
                        triggersChildList &&
                        subSection.__typename === 'DepartmentNavigationListSubSection'
                      ) {
                        navContext?.onSetActiveSubSection(subSection)
                        navContext?.onSetActiveTertiaryItems(subSection.items)
                      } else if (subSection.titleLink) {
                        onNavItemSelected(subSection.titleLink)
                      }
                    }}
                  >
                    <span className={styles.listItemContents}>
                      <span className={styles.listItemLabel}>{subSection.title}</span>
                      <span
                        className={classNames(styles.listItemIcon, {
                          [styles.hiddenArrow]: !triggersChildList
                        })}
                      >
                        <ArrowRight />
                      </span>
                    </span>
                  </li>
                )
              })}
          </ul>
        </GridItem>
      </Grid>
    </div>
  )
}

export default ActiveSubSectionsMenu
